// extracted by mini-css-extract-plugin
export var locationCard = "_rl-0";